import axios from 'axios'
import { AuthError, authActions } from 'feature/auth/redux/authSlice'
import { store } from 'store'

import { apiPath, apiPathLkp } from './apiVariables'

// запросы к API без авторизации
export const sendRequestNoAuth = axios.create({
  baseURL: apiPath,
})

export const sendRequestNoAuthLkp = axios.create({
  baseURL: apiPathLkp,
})

// перехватываем ошибки
sendRequestNoAuth.interceptors.response.use(
  response => response,
  async error => {
    const { dispatch } = store

    switch (error.response.status) {
      case 401:
        dispatch(authActions.setAuthInfo({ error: AuthError.tokenExpired }))
        break
      case 403:
        dispatch(authActions.setAuthInfo({ error: AuthError.accessDenied }))
        break
      case 423:
        dispatch(authActions.setAuthInfo({ error: AuthError.userWasBlock }))
        break
    }

    return Promise.reject(error)
  },
)
